import { forwardRef, HTMLAttributes } from "react"
import { CSSTransition } from "react-transition-group"
import cn from "classnames"

import { Box, Button, Text } from "ui-kit/components-branded/index"
import { Shield } from "modules/Call/components/SafetyPopover/Shield"
import styles from "modules/Call/components/SafetyPopover/Popover/style.module.scss"

interface Props extends HTMLAttributes<HTMLDivElement> {
    shown: boolean
    show(): void
    hide(): void
}

export const Popover = forwardRef<HTMLDivElement, Props>(
    ({ className, shown, hide, show, ...props }, ref) => (
        <div {...props} ref={ref} className={styles.wrapper}>
            <CSSTransition
                classNames="fade-ease-out"
                timeout={100}
                in={shown}
                appear
                unmountOnExit
                onEntered={show}
                onExit={hide}
            >
                <Box className={cn(styles.body, className)}>
                    <Shield isAccent>Ваш звонок защищен</Shield>
                    <p className="mgt-3">
                        <Text color="secondary">Шифрование</Text> <br />
                        <Text>Включено</Text>
                    </p>
                    <p className="mgt-3">
                        <Text color="secondary">Запись звонка</Text> <br />
                        <Text>Не ведется</Text>
                    </p>
                    <p className="mgt-3 mgb-3">
                        <Text color="secondary">Сертификация конфиденциальности </Text> <br />
                        <Text>
                            <a
                                href="https://voximplant.com/blog/hipaa-compliance"
                                target="_blank"
                                rel="noreferrer"
                                className="is-nowrap link-primary"
                            >
                                HIPAA Compliant
                            </a>
                            ,{" "}
                            <a
                                href="https://voximplant.com/blog/iso-27001"
                                target="_blank"
                                rel="noreferrer"
                                className="is-nowrap link-primary"
                            >
                                ISO 27001 Compliant
                            </a>
                        </Text>
                    </p>
                    <Button className="after-call__transparent-button" isFullwidth>
                        Отлично
                    </Button>
                </Box>
            </CSSTransition>
        </div>
    )
)

Popover.displayName = "Popover"
